import { useEffect, useState } from "react";
import { Button, Modal } from "antd";

import { IBVModal } from "./bv-modal";
import BVInput from "../../../../../../../../../common/components/BVControls/BVInput/bv-input";
import BVTextArea from "../../../../../../../../../common/components/BVControls/BVTextArea/bv-text-area";
import BVContainerLoader from "../../../../../../../../../common/components/BVContainerLoader/bv-container-loader";

import { IConfirmForm, useConfirmForm, CancelFormValidator } from "./hooks/useConfirmForm";
import { useAcceptanceBookedForSales } from "../../../../../../../hooks/useAcceptanceBookedForSales";

import { BookedForSalesProduct } from "../../../../../../../../../api-client";

import "./bv-cancel-modal.scss";

interface IBVCancelModal extends IBVModal {
	bookedForSalesProduct: BookedForSalesProduct;
	onAccept: () => void;
}

const BVCancelModal: React.FC<IBVCancelModal> = ({
	title,
	visible,
	onCancel,
	onOk,
	onAccept,
	bookedForSalesProduct
}) => {

	const [formErrors, setFormErrors] = useState<any>({});

	const { handleInitialize, handleChange, formValues } = useConfirmForm();
	const { handleCancelModal, cancelBookedForSalesLoading } = useAcceptanceBookedForSales();

	useEffect(() => {
		if (visible) {
			let formInitializer: IConfirmForm = {
				shipTo: "",
				poNumber: "",
				note: "",
				reasonWhy: "",
				sendToSap: true
			};
			handleInitialize(formInitializer);

			setFormErrors({});
		}
	}, [visible]);

	const handleCancel = () => {
		onCancel();
	};

	const handleConfirm = () => {
		const cancelBookedForSales = {
			reasonWhyCancel: formValues.reasonWhy || "",
			note: formValues.note || ""
		};

		if (bookedForSalesProduct.id) {
			let validationResult = {};
			validationResult = CancelFormValidator.validateForm(formValues);
			setFormErrors(validationResult);

			if (Object.keys(validationResult).length === 0) {
				handleCancelModal(
					bookedForSalesProduct.id,
					cancelBookedForSales,
					onOk,
					onAccept
				);
			}

		}
	};

	const handleReasonWhyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		handleChange("reasonWhy", event.target.value);
	};

	const handleNoteChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
		handleChange("note", event.target.value);
	};

	return (
		<Modal
			title={title}
			visible={visible}
			footer={null}
			onOk={onOk}
			onCancel={onCancel}
			confirmLoading={cancelBookedForSalesLoading}
		>
			<div className="form-group">
				<BVInput
					label={"Cancellation Reason:"}
					errorMessage={formErrors.reasonWhy}
					required
					properties={{
						placeholder: "Enter Cancellation Reasons...",
						value: formValues.reasonWhy,
						onChange: handleReasonWhyChange
					}}
				/>
				<BVTextArea
					label={"Note:"}
					errorMessage={formErrors.note}
					required
					properties={{
						placeholder: "Enter Notes...",
						value: formValues.note,
						onChange: handleNoteChange
					}}
				/>
			</div>

			<div className="confirm-buttons">
				<Button
					type="primary"
					size={"large"}
					onClick={handleCancel}
					style={{
						color: "#000000",
						borderColor: "#999999",
						backgroundColor: "#FFFFFF",
						paddingInline: "25px"
					}}
				>
					{"Undo"}
				</Button>

				<Button
					type="primary"
					size={"large"}
					onClick={handleConfirm}
					disabled={cancelBookedForSalesLoading}
					style={{
						color: "#fff",
						borderColor: "#999999",
						backgroundColor: "#8B0000",
						marginLeft: "20px",
						paddingInline: "25px"
					}}
				>
					{"Cancel Order"}
				</Button>
			</div>
			<BVContainerLoader loading={cancelBookedForSalesLoading} />
		</Modal>
	);
};

export default BVCancelModal;